import React from 'react';
import { Divider } from '@mantine/core';

export function SidebarDivider() {
  return <Divider my={4} ml="xxxs" color="gray.4" />;
}

